<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateSubDepartment"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md h-full md:h-auto shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">
              Add Sub Deparment to {{ selectedRow?.Name }}
            </p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="grid grid-cols-2 gap-5 items-center my-4">
              <div class="text-sm">
                <label class="block pb-1 text-xs">Sub Department Name</label>
                <input
                  required
                  v-model="info.Name"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Sub Department Manager</label>

                <el-select
                  v-model="info.SubDepartmentManagerId"
                  placeholder=""
                  class="w-full"
                >
                  <el-option
                    v-for="jobTitle in jobTitles"
                    :key="jobTitle.Id"
                    :label="jobTitle.Name"
                    :value="jobTitle.Id"
                  >
                    {{ jobTitle.Name }}
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";
export default {
  name: "CompanySetupSubAddDepartment",
  props: ["showCreateSubDepartment", "selectedRow", "reload"],
  components: { Loader },
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      saved_departments: [],
      employees: [],
      linemanagers: [],
      employeeId: null,
      employeesToSelect: null,
      jobTitles: [],
      info: {
        Name: null,
        SubDepartmentManager: null,
        SubDepartmentManagerId: "",
        Fullname: "",
      },
      departments: [
        {
          department: null,
          lineManager: null,
        },
      ],
      create_error: null,
      loading: false,
    };
  },
  created() {
    this.getDepartments();
    this.getLinemanagers();
    this.getEmployees();
    this.getJobTitles();
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  watch: {
    showCreateSubDepartment(newState) {
      if (newState) {
        this.getJobTitles();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addDepartment() {
      this.departments.push({
        department: null,
        lineManager: null,
      });
    },
    removeDepartment(index) {
      this.departments.splice(index, 1);
    },
    async fetchEmployees(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        callback(this.employees);
      } else {
        callback(this.employees);
      }
    },
    findEmployeeId(name) {
      this.employeeId = this.employees.find(
        (employee) =>
          employee.Fullname.trim().toLowerCase() ===
          name.Fullname.trim().toLowerCase()
      ).Id;
    },
    // /{organization}/setup/department/subdepartment/v1/create
    create() {
      this.loading = true;
      // const { DepartmentId } = this.selectedRow;
      //console.log(this.info)
      const { DepartmentId } = this.selectedRow;
      this.info["DepartmentId"] = DepartmentId;
      delete this.info.SubDepartmentManager;
      delete this.info.Fullname;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .post(
          `${this.getOrganization}/setup/department/subdepartment/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              // this.$emit("closeOnSuccess");
              this.reload();
              this.close();
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
            } else {
              // this.create_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            // this.create_error = error.message;
            this.$notify.error({ title: "Failure", message: error.message });
          }
        );
    },
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          //console.log(response.data)
          this.employees = response.data.Data;
          //console.log(this.employees)
        });
    },

    getJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.jobTitles = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.saved_departments = response.data.Data;
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    getLinemanagers() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/linemanagers/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            //console.log(response);
            if (response.data.StatusCode == 200) {
              this.linemanagers = response.data.Data;
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
